<ng-container *ifScreenSize="screenType.Desktop">
  <ng-container *notInPopulation="[populations.Kids]">
    <div class="bg-primary"  *ngIf="showBanner">
      <img class="w-100" src="assets/images/rewards-banner-desktop.png" />
    </div>
  </ng-container>
</ng-container>
<ng-container *ifScreenSize="screenType.Mobile">
  <div class="page-header bg-primary" [ngClass]="{ 'hide-footer': !showFooter }">
    <div class="d-flex align-items-center text-white">
      <div class="banner-name">
        <a (click)="goBack()" class="btn back-btn text-white px-0">
          <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
        </a>
        <h4 class="page-title mb-0 font-size-18" [ngClass]="{ 'text-title-center': !showBalance }">
          {{ pageTitle | translate | uppercase }}
        </h4>
      </div>
      <div class="ms-auto d-flex align-items-center font-size-14 widget-details" *ngIf="showBalance">
        <div class="balance-details d-flex bg-gradients align-items-center">
          <span class="icon material-icons">loyalty</span>
          <div class="balance">
            <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
          </div>
        </div>

        <button class="qrcode-btn text-white bg-gradients" routerLink="{{ qrButtonLink }}">
          <span class="icon material-icons material-mobile-nav">qr_code_2</span>
        </button>
      </div>
    </div>
    <ng-container *notInPopulation="[populations.Kids]">
      <div class="bg-primary"  *ngIf="showBanner">
        <img class="w-100 rounded mb-2" src="assets/images/home/haws-rewards-banner.jpg" />
      </div>
    </ng-container>
    <div class="footer"></div>
  </div>
</ng-container>
